// Loads native Shopify product recommendations into their section (Section Rendering API).
(() => {
  document.querySelectorAll('[data-recommendations]').forEach(async (root) => {
    if (root.querySelector('.recommendations__inner')) return;
    try {
      const response = await fetch(root.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const fresh = html.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('.recommendations__inner')) root.innerHTML = fresh.innerHTML;
    } catch (error) {
      // Recommendations are optional; the page is complete without them.
    }
  });
})();
